import {Component, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Alumno} from '../../interfaces/interfaces';

@Component({
  selector: 'app-nofotos',
  templateUrl: './nofotos.component.html',
  styleUrls: ['./nofotos.component.scss'],
})
export class NofotosComponent {

  @Input() alumnos: Alumno[];

  constructor(
    public modalCtrl: ModalController
  ) {}

}
